export default "__VITE_ASSET__3xjSp3mA__"